/**
 * Mapowanie nazwy trasy (routing plikowy Nuxt) na `page.type` w zdarzeniu
 * `page_view` na warstwie danych.
 *
 * To KONTRAKT dla partnerów czytających dataLayer (Segmentify): po tym polu
 * rozpoznają rodzaj strony w SPA, gdzie nie ma przeładowania dokumentu ani
 * zmiennych szablonu sklepu. Zmiana wartości = zmiana kontraktu — uzgadniaj ją
 * z partnerem. Zob. plugins/datalayer-pageview.client.ts.
 */
export function dataLayerPageType(routeName: string): string {
  const name = routeName || ''
  if (name === 'index') return 'home'
  if (name.startsWith('products-slug')) return 'product'
  if (name.startsWith('marka') || name === 'marki') return 'brand'
  if (name === 'nowosci' || name === 'slug') return 'category'
  if (name.startsWith('checkout')) return 'checkout'
  if (name === 'cart') return 'cart'
  if (name === 'thank-you' || name.startsWith('zamowienie')) return 'confirmation'
  if (name.startsWith('search')) return 'search'
  // Ulubione mają WŁASNY typ (nie 'account') — partner rozpoznaje po nim stronę
  // listy życzeń (jego zdarzenie WISHLIST / view-favorites); zlanie jej z panelem
  // klienta odbierało mu tę informację.
  if (name === 'favorites') return 'wishlist'
  if (name.startsWith('account')) return 'account'
  if (name.startsWith('auth')) return 'auth'
  return 'other'
}
